/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RoleType {
    VALIDATOR = 'validator',
    FULL_NODE = 'full_node',
}
